var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "payin-toolbar-wrapper" }, [
    _c(
      "div",
      { staticClass: "left-area", class: { disabled: _vm.bettingLocked } },
      [
        _vm.config.totalStake
          ? _c(
              "div",
              {
                staticClass: "stake-input",
                on: { click: _vm.setTotalPaymentFocus },
              },
              [
                _c("label", { staticClass: "input-label" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("translate")("general_total_stake")) +
                      " "
                  ),
                ]),
                _c("input", {
                  ref: "totalPayment",
                  staticClass: "input no-spinner",
                  attrs: {
                    id: "stake",
                    inputmode: "decimal",
                    type: _vm.mobile ? "text" : "number",
                    readonly: _vm.mobile,
                  },
                  domProps: { value: _vm.totalPayment.toFixed(2) },
                  on: {
                    blur: _vm.changeTotalStake,
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.changeTotalStake.apply(null, arguments)
                    },
                  },
                }),
                _c("i", {
                  staticClass: "icon icon-backspace-a",
                  on: {
                    click: function ($event) {
                      return _vm.clearStake($event)
                    },
                  },
                }),
              ]
            )
          : _vm._e(),
        _vm.config.winnings
          ? _c("div", { staticClass: "possible-winning" }, [
              _c("label", { staticClass: "input-label winnings" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm._f("translate")("general_possible_winning")) +
                    " "
                ),
              ]),
              _c("input", {
                staticClass: "input no-spinner",
                attrs: {
                  id: "posible-winning",
                  disabled: "",
                  "data-layout": "numeric",
                  inputmode: "numeric",
                  type: "number",
                },
                domProps: { value: _vm.possibleWinnigs },
              }),
            ])
          : _vm._e(),
        _vm.config.futureBets
          ? _c("div", { staticClass: "future-bets-input" }, [
              _c(
                "label",
                { staticClass: "input-label", attrs: { for: "future-rounds" } },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("translate")("general_future_bet")) +
                      " "
                  ),
                ]
              ),
              _c("input", {
                staticClass: "input no-spinner",
                class: { disabled: _vm.totalStakeDisabled },
                attrs: {
                  id: "future-rounds",
                  disabled: _vm.totalStakeDisabled,
                  "data-layout": "numeric",
                  inputmode: "numeric",
                  type: "number",
                },
                domProps: { value: _vm.futureBets },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.changeFutureBets.apply(null, arguments)
                  },
                  blur: _vm.changeFutureBets,
                },
              }),
            ])
          : _vm._e(),
      ]
    ),
    _c("div", { staticClass: "right-area" }, [
      _vm.config.addBet
        ? _c(
            "button",
            {
              staticClass: "button add-button",
              class: {
                disabled:
                  !_vm.bettingEnabled ||
                  !_vm.actionsEnabled ||
                  _vm.bettingLocked,
              },
              attrs: {
                disabled:
                  !_vm.bettingEnabled ||
                  !_vm.actionsEnabled ||
                  _vm.bettingLocked,
              },
              on: { click: _vm.addBetToBetslip },
            },
            [_vm._v(" " + _vm._s(_vm._f("translate")(_vm.addLabel)) + " ")]
          )
        : _vm._e(),
      _vm.config.addBet
        ? _c(
            "button",
            {
              staticClass: "button add-button mobile",
              class: {
                disabled:
                  !_vm.bettingEnabled ||
                  !_vm.actionsEnabled ||
                  _vm.bettingLocked,
              },
              attrs: {
                disabled:
                  !_vm.bettingEnabled ||
                  !_vm.actionsEnabled ||
                  _vm.bettingLocked,
              },
              on: { click: _vm.addBetToBetslip },
            },
            [_c("i", { staticClass: "icon icon-plus" })]
          )
        : _vm._e(),
      !_vm.player.loggedIn
        ? _c(
            "button",
            {
              staticClass: "button login-button important",
              on: {
                click: function ($event) {
                  return _vm.login()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm._f("translate")("general_sign_in")) + " ")]
          )
        : _vm._e(),
      _vm.player.loggedIn
        ? _c(
            "button",
            {
              staticClass: "button payin-button important",
              class: { disabled: _vm.payinDisabled },
              attrs: { disabled: _vm.payinDisabled },
              on: { click: _vm.payinTicket },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm._f("translate")("general_pay_in")) +
                  " " +
                  _vm._s(_vm.config.addBet ? _vm.betsLength : "") +
                  " "
              ),
            ]
          )
        : _vm._e(),
      _c(
        "button",
        {
          staticClass: "button betslip-button",
          class: {
            active:
              _vm.ticket.bets.length && !_vm.showBetslip && !_vm.quickPayin,
          },
          on: {
            click: function ($event) {
              return _vm.toggleBetslip()
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "items-indicator",
              class: {
                active:
                  _vm.ticket.bets.length && !_vm.showBetslip && !_vm.quickPayin,
              },
            },
            [_vm._v(" " + _vm._s(_vm.ticket.bets.length) + " ")]
          ),
          _c("i", { staticClass: "icon", class: _vm.betslipIcon }),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showBetslip,
              expression: "showBetslip",
            },
          ],
          staticClass: "betslip-component",
        },
        [
          _c(
            "div",
            { staticClass: "betslip-header" },
            _vm._l(_vm.ticketWrapperTabs, function (tab, key) {
              return _c(
                "div",
                {
                  key: key,
                  staticClass: "header-item",
                  class: {
                    active: key === _vm.selectedTicketTab,
                    disabled: tab.disabled,
                  },
                  attrs: { disabled: tab.disabled },
                  on: {
                    click: function ($event) {
                      return _vm.selectTab(key)
                    },
                  },
                },
                [
                  _vm._v(" " + _vm._s(_vm._f("translate")(tab.name)) + " "),
                  tab.indicator && _vm.ticket.bets.length
                    ? _c("BetslipMetaInfo")
                    : _vm._e(),
                ],
                1
              )
            }),
            0
          ),
          _c(
            "div",
            { staticClass: "betslip-content" },
            [
              _vm.selectedTicketTab === 0
                ? _c("ExpandedBetslip", {
                    attrs: { bettingLocked: _vm.bettingLocked },
                  })
                : _vm._e(),
              _vm.selectedTicketTab === 1
                ? _c("LastTickets", { attrs: { tickets: _vm.lastTicketsData } })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }